var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.getIsPrintablePDFMode)?_c('input',{class:_vm.style,attrs:{"type":_vm.type},domProps:{"value":_vm.value},on:{"change":_vm.update}}):_c('span',{staticClass:"spanned-input"},[_vm._v(_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }